import { SharePointListClient, type ListItem } from '../SharePointListClient';

/** 99.ABM_Categorias — simple name catalogue, referenced by CuentaContable + Articulos. */
export type CategoriasFields = {
  Title?: string | null;
  Categoria_CAT?: string | null;
  Status_CAT?: 'Activo' | 'Inactivo' | string | null;
};

export type CategoriaItem = ListItem<CategoriasFields>;

export const categoriasClient = new SharePointListClient<CategoriasFields>('ABM_Categorias');

export async function listAllCategorias(): Promise<CategoriaItem[]> {
  return categoriasClient.listItems({ top: 5000 });
}

export async function listActiveCategorias(): Promise<CategoriaItem[]> {
  return categoriasClient.listItems({
    filter: "fields/Status_CAT eq 'Activo'",
    orderBy: 'fields/Categoria_CAT asc',
  });
}

export async function createCategoria(nombre: string): Promise<CategoriaItem> {
  return categoriasClient.createItem({
    Title: '[sumar]',
    Categoria_CAT: nombre.trim(),
    Status_CAT: 'Activo',
  });
}

export async function updateCategoria(id: string, nombre: string): Promise<CategoriaItem> {
  return categoriasClient.updateItem(id, { Categoria_CAT: nombre.trim() });
}

export async function softDeleteCategoria(id: string): Promise<CategoriaItem> {
  return categoriasClient.updateItem(id, { Status_CAT: 'Inactivo' });
}
